import { render, staticRenderFns } from "./InviteDialog.vue?vue&type=template&id=4dadaab7&scoped=true&"
import script from "./InviteDialog.vue?vue&type=script&lang=js&"
export * from "./InviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadaab7",
  null
  
)

export default component.exports